<template>
  <div
    class="filter-concise-summary" 
    @click="onClick"
    @mouseover="showEditIcon = true"
    @mouseout="showEditIcon = false"
  >
    <div
      v-for="(orFilter, index) in normalizedFilters"
      :key="index"
      class="filter-or-bg clickable"
    >
      <strong
        v-if="index !== 0"
        class="filter-comparison"
        :title="$t('EDIT_FILTERS')"
        :class="{'filter-comparison--and p-10 m-r-5 bg-holder': orFilter.andCriteriaStart, 'filter-comparison--or': !orFilter.andCriteriaStart }"
      >
        {{ orFilter.andCriteriaStart ? $t('ROUTER_FILTER_AND').toLowerCase() : $t('ROUTER_FILTER_OR').toLowerCase() }}
      </strong>

      <span :title="$t('EDIT_FILTERS')">{{ orFilter.tagDisplay }}</span>

      <i
        class="m-l-5 m-r-5 f-s-11"
        :title="$t('EDIT_FILTERS')"
      >{{ orFilter.comparisonTypeTemp.value | camelCaseFormat }}</i>

      <strong
        v-if="!isArray(orFilter.value)"
        class="contrast"
        :title="$t('EDIT_FILTERS')"
      >
        {{ orFilter.value }}
      </strong>

      <span v-if="isArray(orFilter.value)">
        <strong
          v-for="(value, valueIndex) in orFilter.value"
          :key="valueIndex"
          :title="$t('EDIT_FILTERS')"
          class="contrast"
        >
          {{ value }}
          <span
            v-if="valueIndex !== (orFilter.value.length - 1)"
            class="text-muted divider"
            :title="$t('EDIT_FILTERS')"
          >|</span>
        </strong>
      </span>
      <i
        class="fa fa-times m-l-5 delete-criteria"
        :title="$t('DELETE_CRITERIA')"
        @hover.stop="showEditIcon = false"
        @click.stop="onDeleteOrCriteria(orFilter.orIndex, orFilter.andIndex)"
      />
    </div>

    <i
      v-show="showEditIcon"
      class="fa fa-pencil m-l-5"
      :title="$t('EDIT_FILTERS')"
      @click="onClick"
    />
  </div>
</template>

<script>
import { tagIdToText } from '@/core/filters/tagIdToText';
import messages from '../locales';
import { geoTagsIds } from '@/data/filterData';
import USStatesList from '@/data/USStatesList';

export default {
  name: 'FilterCriteriaConciseSummary',
  props: {
    filterCriteria: {
      type: Array,
      default() {
        return [];
      }
    },
    availableTags: {
      type: Array,
      default() {
        return [];
      }
    },
    tagIdToText: {
      type: Function,
      default(tagId) {
        return tagIdToText(tagId, this.availableTags);
      }
    }
  },
  data() {
    return {
      showEditIcon: false
    };
  },
  computed: {
    normalizedFilters() {
      let normalized = [];

      for (let andIndex = 0; andIndex < this.filterCriteria.length; andIndex++) {
        const andCriteria = this.filterCriteria[andIndex];
        for (let orIndex = 0; orIndex < andCriteria.tagCriteria.length; orIndex++) {
          const orCriteria = andCriteria.tagCriteria[orIndex];
          normalized.push({
            ...orCriteria,
            tagDisplay: this.tagIdToText(orCriteria.tagId, this.availableTags),
            andCriteriaStart: orIndex === 0,
            andIndex,
            orIndex
          });
        }
      }

      return normalized;
    }
  },
  methods: {
    isArray(value) {
      return Array.isArray(value);
    },
    orderedStates(states) {
      if (!states) {
        return [];
      }

      return states.sort();
    },
    getStateDisplayName(tagId, stateValue) {
      if (getStateValueProperty(tagId) === 'abbreviation') {
        return USStatesList.find(function findState(state) {
          return state['abbreviation'] === stateValue;
        }).name;
      }
      
      return stateValue;
    },
    onClick() {
      this.$emit('click');
    },
    onDeleteOrCriteria(orIndex, andIndex) {
      this.$emit('deleteOrCriteria', orIndex, andIndex);
    }
  },
  i18n: {
    locale: 'en',
    messages
  }
};


/**
 * Get state value property used by the tag ID.
 * Different values are used in the backend for different tag IDs.
 * Some use the state abbreviation while some use the full state name
 */
function getStateValueProperty(tagId) {
  geoTagsIds.find(function findGeoTagIdConfig(geoTag) {
    return tagId.toLowerCase() === geoTag.tagId.toLowerCase();
  });
}

</script>

<style lang="scss" scoped>
.filter-or-bg {
  background: var(--component-filter-concise-summary-bg);
  padding: 5px 8px;
  margin-bottom: 5px;
  display: inline-block;
  font-size: 1.1em;
  &:not(:first-child) {
    padding-left: 0;
  }
  
  .delete-criteria:hover {
    color: var(--component-btn--function--hover-font-color);
  }
}

.filter-comparison--and {
  background: var(--component-widget-panel__holder-bg); // change this
}

.filter-comparison--or {
  color: grey;
  padding: 5px 9px 5px 3px;
}
</style>